(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["famli-cro-content"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', event => {
  const trigger = event.target.closest('[data-scanner-hotspot]');
  if (!trigger) return;
  const panel = document.getElementById(trigger.dataset.scannerHotspot);
  if (!panel) return;
  const section = trigger.closest('.sm-cro');
  section.querySelectorAll('.sm-cro__anatomy details').forEach(detail => { detail.open = detail === panel; });
  section.querySelectorAll('[data-scanner-hotspot]').forEach(dot => dot.setAttribute('aria-expanded', String(dot === trigger)));
  panel.querySelector('summary').focus({preventScroll:true});
  requestAnimationFrame(() => panel.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',block:'start'}));
});
document.addEventListener('toggle', event => {
  const panel = event.target;
  if (!panel.matches('.sm-cro__anatomy details')) return;
  const section = panel.closest('.sm-cro');
  const dot = section.querySelector('[data-scanner-hotspot="' + panel.id + '"]');
  if (dot) dot.setAttribute('aria-expanded', String(panel.open));
}, true);

  } catch(e) { console.error(e); }
})();
})();
